import {
	performPostRequest,
	performPutRequest,
	performDeleteRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	getCmdbObjectAttributeByObjectTypeAttributeIdCreateUrl,
	getCmdbObjectAttributeByObjectTypeAttributeIdUrl,
} from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object-attribute.tsx';
import type { AttributeUpdateResponse } from '../../common/types/object-attribute.tsx';
import type { RequestBody } from './types.tsx';

export const ObjectAttributeService = {
	createAttribute: ({
		workspaceId,
		body,
	}: {
		workspaceId: string;
		body: RequestBody;
	}): Promise<AttributeUpdateResponse> =>
		performPostRequest(
			getCmdbObjectAttributeByObjectTypeAttributeIdCreateUrl(
				workspaceId,
				body.objectId,
				body.objectTypeAttributeId,
			),
			{
				body: JSON.stringify(body),
			},
		).then((response) => {
			const { workspaceId: wsid, ...attribute } = response;
			return attribute;
		}),

	updateAttribute: ({
		workspaceId,
		body,
	}: {
		workspaceId: string;
		body: RequestBody;
	}): Promise<AttributeUpdateResponse> =>
		performPutRequest(
			getCmdbObjectAttributeByObjectTypeAttributeIdUrl(
				workspaceId,
				body.objectId,
				body.objectTypeAttributeId,
			),
			{
				body: JSON.stringify(body),
			},
		),

	deleteAttribute: ({
		workspaceId,
		objectId,
		objectTypeAttributeId,
	}: {
		workspaceId: string;
		objectId: string;
		objectTypeAttributeId: string;
	}): Promise<void> =>
		performDeleteRequest(
			getCmdbObjectAttributeByObjectTypeAttributeIdUrl(
				workspaceId,
				objectId,
				objectTypeAttributeId,
			),
		),
} as const;
